export default "https://event-api.artbyform.com";
